import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-no-access-rights',
  templateUrl: './no-access-rights.component.html',
  styleUrls: ['./no-access-rights.component.scss']
})
export class NoAccessRightsComponent {
  /**
   *
   */
  constructor(
    private router : Router
  ) {}
  submit() {
    this.router.navigateByUrl('')
  }
}
